// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

import { mobileMediaCondition } from 'utils/helpers/device-utils';

export const SearchPanelFullWrapper = styled.div`
    position: relative;

    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    width: 100%;
    max-width: 100vw;
    height: max-content;
    max-height: 90vh;
    padding: 5px 0;
    @media ${mobileMediaCondition} {
        gap: 4px;
    }

    @media ${mobileMediaCondition} {
        max-width: max(320px, 100vw);
        /*max-height: 90dvh;*/
        margin-top: 48px;
    }
`;

export const DataWrap = styled.div`
    position: ${({ isSearchPanel }) => (isSearchPanel ? 'absolute' : undefined)};
    top: ${({ isSearchPanel }) => (isSearchPanel ? '50px' : undefined)};
    z-index: ${({ isSearchPanel }) => (isSearchPanel ? 1 : undefined)};

    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-height: ${({ isSearchPanel }) => (isSearchPanel ? '75vh' : undefined)};
    padding: 6px 6px;
    overflow: auto;

    border-radius: 8px;

    background-color: var(--backgroundColorSecondary);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        border-radius: 6px;

        box-shadow: inset 0 0 6px var(--uiPrimaryColor);
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 8px;

        box-shadow: inset 0 0 6px var(--uiPrimaryColor);
    }

    @media ${mobileMediaCondition} {
        gap: 8px;
        width: ${({ isSearchPanel }) => (isSearchPanel ? '100%' : undefined)};
    }
`;

export const Row = styled.div`
    display: flex;
    gap: 2px;
    justify-content: space-between;
    width: 100%;

    color: var(--defaultColor);

    &:nth-child(even) {
        background-color: #f6f8fb;
    }

    &:nth-child(odd) {
        background-color: #fff;
    }
`;

export const ControlsTab = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const ContentNameItems = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin: 4px 0;
`;

export const PlayerLink = styled.div`
    color: ${({ isActive }) => (isActive ? 'var(--uiPrimaryColor)' : 'var(--defaultColor)')};

    cursor: pointer;

    &:hover {
        color: ${({ isActive }) => (isActive ? 'var(--uiPrimaryColor)' : 'var(--defaultColor)')};
        text-decoration: underline;
    }
`;
